import { isNil } from 'lodash';
import { TokenManager } from 'shared/helpers';

// Constants.
const AI_AUTH_COOKIE_NAME = 'access_token';

const getAIAuthCookie = (): string | undefined => {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${AI_AUTH_COOKIE_NAME}=`));

  return cookie
    ? decodeURIComponent(cookie.slice(`${AI_AUTH_COOKIE_NAME}=`.length))
    : undefined;
};

const getAIAuthCookieAttributes = (): string => {
  const hostname = window.location.hostname;
  const attributes = ['path=/'];

  if (hostname.endsWith('.aereo.co.in')) {
    attributes.push('domain=.aereo.co.in');
    attributes.push('SameSite=None');
    attributes.push('Secure');
  } else if (hostname.endsWith('.aereo.io')) {
    attributes.push('domain=.aereo.io');
    attributes.push('SameSite=None');
    attributes.push('Secure');
  } else {
    attributes.push('SameSite=Lax');
  }

  return attributes.join('; ');
};

/**
 * Ensures the JWT access token is available as a cookie so it can be
 * included in the WebSocket handshake request to the RTI server.
 *
 * The cookie is session-scoped and relies on the JWT's own expiry.
 * A cookie write is skipped when the current value already matches.
 */
export const setAIAuthCookie = (): void => {
  const token = TokenManager.getToken();

  if (isNil(token)) {
    return;
  }

  if (getAIAuthCookie() === token) {
    return;
  }

  document.cookie = `${AI_AUTH_COOKIE_NAME}=${encodeURIComponent(token)}; ${getAIAuthCookieAttributes()}`;
};
